import PatientOverviewSmokingProgress from 'dashboard/templates/views/Patient/SC/PatientOverviewSmokingProgress';

const navigationSteps = {
    nextDiscussionStep: {
        PatientRecordProgressStatus: 'PatientRecordProgressGoalSetting',
    },
    prevDiscussionStep: {
        PatientRecordProgressGoalSetting: 'PatientRecordProgressStatus',
    }
}

export default {
    path: 'progress',
    name: 'PatientRecordSmokingProgress',
    props: navigationSteps,
    component: PatientOverviewSmokingProgress,
    meta: {
        // title: 'Patient Record - Smoke-free living - Progress',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.smokeFreeLivingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')}`,
        // title: 'Smoke-free living - status',
        title: t => `${t('screens.smokeFreeLivingSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    },
    children: [
    ],
};
